import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './screen/login/login';
import Dashboard from './screen/dashboard/dashboard';
import ProtectedRoute from './components/ProtectedRoute';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
      </Routes>
    </Router>
  );
};

export default App;
